export default /* @ngInject */ ($window, $rootScope) => {
	let $win,
		$next,
		$prev,
		$items,
		$element,
		winWidth,
		scrollWidth,
		selectorRaw,
		animDuration,
		stickableWidth,
		columnClassName,
		nCurrentPosition,
		$nScrollableItem,
		nCurrentScrollPos,
		containerClassName,
		ntotalScrollableCols;

	const template = `
	    <div class='scrollable-ctrl' ng-transclude>
		</div>
	`;

	const adjustController = (attrs) => {
		getWidth();
		const stickableScrollable = $(`${attrs.stickable}`);
		const scrollPos = $win.scrollTop();
		const stickAt = attrs.stickAt || 103;

		let styles;

		if (attrs.stickableStyles) {
			styles = attrs.stickableStyles;
		} else {
			styles = `
                    top: 6.9em;
                    left: 5em;
                    width: ${stickableWidth ? stickableWidth + '.5px' : '92.94%'};
                    z-index: 10;
                    position: fixed;
                    background-color: white;
                `;
		}

		if (stickableWidth) {
			styles += `
                    width: ${stickableWidth}.5px;
                `;
		}

		if (scrollPos >= stickAt) {
			stickableScrollable.attr('style', styles);
		} else {
			stickableScrollable.attr('style', '');
		}
	};

	const scrollDir = (dir) => {
		const monthlyActualContainerWidth = $(`.${containerClassName}`).width();
		const nScrollAmount = $(`.${columnClassName}`).width();
		const limitScrolls = Math.trunc(monthlyActualContainerWidth / nScrollAmount);
		const $nScrollableItem = $('.scroll-me');

		if (dir === 'left') {
			if (nCurrentPosition > 0) {
				nCurrentScrollPos += nScrollAmount;

				$nScrollableItem.css({
					transition: 'transform .5s',
					transform: `translateX(${nCurrentScrollPos}px)`
				});
				nCurrentPosition -= 1;
			}
		}

		if (dir === 'right') {
			if (nCurrentPosition < ntotalScrollableCols - limitScrolls) {
				nCurrentScrollPos -= nScrollAmount;

				$nScrollableItem.css({
					transition: 'transform .5s',
					transform: `translateX(${nCurrentScrollPos}px)`
				});
				nCurrentPosition += 1;
			}
		}
	};

	const getWidth = () => {
		stickableWidth = $(`.panel-group .${columnClassName}`).width();
	};

	const init = (numOfCells, column = 'months-container', container = 'monthly-actual-container') => {
		$win = $($window);
		nCurrentPosition = 0;
		nCurrentScrollPos = 0;
		columnClassName = column;
		$next = $('[data-ctrl=next]');
		$prev = $('[data-ctrl=prev]');
		containerClassName = container;

		if (!!numOfCells && typeof numOfCells === 'string') {
			numOfCells = parseInt(numOfCells);
		} else if (!!!numOfCells || numOfCells.length === 0) {
			numOfCells = 12;
		}

		ntotalScrollableCols = numOfCells;
	};

	return {
		template,
		scope: {
			fixed: '=?',
			stickAt: '@',
			stickable: '@',
			numOfCells: '@?',
			targetSelector: '@',
			stickableStyles: '@',
			columnClassName: '@?',
			containerClassName: '@?'
		},
		transclude: true,
		link: (scope, element, attrs) => {
			$element = $(element);
			const numOfCells = scope.numOfCells || null;
			const { columnClassName, containerClassName } = scope;

			init(numOfCells, columnClassName, containerClassName);

			if (attrs.hasOwnProperty('stickable') && attrs.stickable) {
				adjustController(attrs);

				$win.on('scroll', function(evt) {
					adjustController(attrs);
				});
			}

			[ $prev, $next ].forEach(($el) => {
				$el.on('mousedown mouseup click', (evt) => evt.preventDefault());

				$el.on('click', (evt) => {
					const dir = $(evt.currentTarget).hasClass('next') ? 'right' : 'left';
					scrollDir(dir);
				});
			});

			$win.on('resize', () => {
				winWidth = $win.width();
				getWidth();
				adjustController(attrs);
			});

			$rootScope.$on('noOfDocumentsChanged', (evt, data) => {
				const { noOfDocuments } = data;
				if (noOfDocuments) {
					ntotalScrollableCols = noOfDocuments;
				}
			});

			$rootScope.$on('documents-scroller-adjust', (evt, data) => {
				const { dir } = data;
				scrollDir(dir || 'left');
			});
		}
	};
};
